export enum DndItemTypes {
	EDITOR_THUMBNAIL = 'EDITOR_THUMBNAIL',
	DRIVE_ITEM = 'DRIVE_ITEM',
	NATIVE_FILE = '__NATIVE_FILE__',
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/typings/dnd.ts